export default function getURLParams() {
  const params = new URLSearchParams(window ? window.location.search : {});

  const surveyKey = params.getAll("st")[0] || "";
  const companyRegister = params.getAll("id")[0] || "";

  // Caso o ID da empresa seja invalido esta sendo retornado para pagina inicial
  // if (!!!validateUuid(companyRegister)) {
  //   window.location.replace("/");
  // }

  return {
    companyRegister,
    surveyKey,
  };
}
